import styles from './ScrollIndicator.module.sass';
import cn from "classnames";

const ScrollIndicator = ({className, ...props}) => {
	return (
		<div className={cn(styles.scroll_indicator, className, 'gsap-scroll_indicator')} {...props}>
			<span className={styles.text}>SCROLL POUR AVANCER</span>
		</div>
	)
}
export default ScrollIndicator;